import { FC } from 'react';

interface IPoint {
  x: number;
  y: number;
}
interface ICustomActiveDotLineProps {
  height?: number;
  width?: number;
  points?: [IPoint, IPoint];
}
export const CustomActiveDotLine: FC<ICustomActiveDotLineProps> = ({
  height,
  width,
  points,
}) => {
  const [{ x, y }, { x: x1, y: y1 }] = points ?? [
    { x: 0, y: 0 },
    { x: 0, y: 0 },
  ];

  return (
    <g>
      <path
        d={`M${x},${y}L${x1},${y1}`}
        height={height}
        width={width}
        type={'dashed'}
        stroke="var(--icon-link-info)"
        strokeDasharray={3}
      />
      <circle
        cx={x1}
        cy={y1}
        r={2}
        strokeWidth={4}
        fill={'var(--icon-link-info)'}
        stroke={'var(--bg-blue-10)'}
      />
    </g>
  );
};
